let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("glxda")).then(() => parcelRequire('lMQZW'));